import React from 'react';
import { Button, Divider, Form, Input, Modal, notification, Select, Typography } from "antd";
import ApiService from "../../../services/ApiService"
import { EsriProvider } from 'leaflet-geosearch';
import ContactIcon from "../../../components/util-components/ContactIcon";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

const provider = new EsriProvider();
const { Search } = Input;
const { Text } = Typography;
const { Option } = Select;

export default class ModalAddChild extends React.Component {

    constructor(props) {
        super(props);
        props.getRef(this)
    }

    initialState = {
        visible: false,
        loading: false,
        id: null,
        edit: false,
        parent: null,
        childId: null,
        defaultData: {},
        categories: [],
        selectedCategories: [],
        adresseOptions: [],
        contacts: []
    };

    state = this.initialState

    async show(parent) {
        await this.init()
        await this.initContact()
        this.setState({ visible: true, parent: parent })
    }

    async initContact() {
        var res = await ApiService.get("/contact/form")
        this.setState({ contacts: res.data })
    }

    onSearch = (text) => {
        this.setState({ text });
    }

    close() {
        this.setState(this.initialState)
    }

    componentDidMount() {
        this.init()
    }

    async init() {
        var res = await ApiService.get("/contact/categories")
        if (res.success) {
            this.setState({ categories: res.items })
        }
    }

    async onSelect() {
        if (!this.state.childId) {
            return false
        }

        var res = await ApiService.post("/contact/child/add/" + this.state.parent, { childId: this.state.childId })

        if (res.success) {
            notification.success({
                message: this.state.edit ? t`Succès de la modification` : t`Succès de l'ajout`
            })

            this.close()
            if (this.props.onFinish) {
                this.props.onFinish(res.id)
            }
        } else {
            notification.error({
                message: this.state.edit ? t`Erreur lors de la modification` : t`Erreur lors de l'ajout`
            })
        }
    }

    async onSubmit(data) {

        data.categories = this.state.selectedCategories

        if (this.state.edit && !this.state.id) {
            notification.error({
                message: t`Erreur lors de la modification`
            })
            this.close()
            return false
        }

        if (this.state.edit) {
            data.id = this.state.id
        }

        var res = await ApiService.post("/contact/child/add/" + this.state.parent, data)

        if (res.success) {
            notification.success({
                message: this.state.edit ? t`Succès de la modification` : t`Succès de l'ajout`
            })

            this.close()
            if (this.props.onFinish) {
                this.props.onFinish(res.id)
            }
        } else {
            notification.error({
                message: this.state.edit ? t`Erreur lors de la modification` : t`Erreur lors de l'ajout`
            })
        }
    }

    render() {

        return (
            <Modal
                width="100%"
                title={this.state.edit ? t`Éditer un Enfant` : t`Ajouter un Enfant`}
                open={this.state.visible}
                destroyOnClose
                closable
                footer={null}
                onCancel={() => this.close()}
            >
                <Divider><Trans>Choisir un Enfant</Trans></Divider>

                <Form>
                    <Form.Item>
                        <Select
                            showSearch
                            filterOption={(input, option) => {
                                var text = option.props.children
                                if (Array.isArray(text)) {
                                    text = text.join("")
                                }
                                return text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }}
                            placeholder={t`Choisir un enfant`}
                            value={this.state.selectedContacts}
                            onSelect={(value) => {
                                this.setState({ childId: value })
                            }}
                        >
                            {this.state.contacts.map((item, index) => {
                                var email = item.email ? `(${item.email})` : ""
                                var tel = item.tel ? `(${item.tel})` : ""
                                return (
                                    <Select.Option key={index} value={item.id}>
                                        <ContactIcon contact={item} /> {item.nom} {item.prenom} {tel} {email}
                                    </Select.Option>
                                )
                            })}
                        </Select>
                    </Form.Item>

                    <Form.Item style={{ display: "flex", justifyContent: "flex-end" }}>
                        <Button type="primary" onClick={() => this.onSelect()} loading={this.state.loading}>
                            <Trans>Valider</Trans>
                        </Button>
                    </Form.Item>
                </Form>

                <Divider><Trans>Nouvel enfant</Trans></Divider>

                <Form
                    ref={(ref) => this.form = ref}
                    initialValues={this.state.defaultData}
                    onFinish={(data) => this.onSubmit(data)}
                >

                    <Form.Item
                        label={<Trans>Nom</Trans>}
                        name="nom"
                        rules={[{ required: true, message: t`Ce champ est obligatoire` }]}
                    >
                        <Input placeholder={t`Nom`} />
                    </Form.Item>

                    <Form.Item
                        label={<Trans>Prénom</Trans>}
                        name="prenom"
                        rules={[{ required: true, message: t`Ce champ est obligatoire` }]}
                    >
                        <Input placeholder={t`Prénom`} />
                    </Form.Item>

                    <Form.Item style={{ display: "flex", justifyContent: "flex-end" }}>
                        <Button type="primary" htmlType="submit" loading={this.state.loading}>
                            <Trans>Valider</Trans>
                        </Button>
                    </Form.Item>

                </Form>
            </Modal>
        )
    }
}
